import { render, staticRenderFns } from "./navigation-btn.vue?vue&type=template&id=046acaac&"
import script from "./navigation-btn.vue?vue&type=script&lang=js&"
export * from "./navigation-btn.vue?vue&type=script&lang=js&"
import style0 from "./_navigation-btn.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports